import { useQuery } from "@tanstack/react-query";
import { getThirdPartyContracts } from "../../services/pdmApi.service";

export function useThirdPartyContractsList(applied: {
  network: string;
  networkType: string;
}) {
  return useQuery({
    queryKey: ["thirdPartyContracts", applied.network, applied.networkType],
    queryFn: () =>
      getThirdPartyContracts({
        network: applied.network.trim() || undefined,
        networkType: applied.networkType.trim() || undefined,
      }),
  });
}
